import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { Card } from "@mui/material";
import decryptData from "../decrypt";
import { handleLogout } from "../config/axios";

export default function OrdiniDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [collapseActive, setCollapseActive] = useState(false);
  const [addresses, setAddresses] = useState([]);
  
  // Ottieni il tema corrente dallo store Redux
  const currentTheme = useSelector((state: any) => state.menu.theme);
  const [theme, setTheme] = useState(currentTheme);

  // Aggiorna il tema quando cambia nello store
  useEffect(() => {
    setTheme(currentTheme);
  }, [currentTheme]);


  const baseClasses = {
    background: theme === 'dark' ? '' : 'bg-gray-50',
    card: theme === 'dark' ? 'bg-black-500 border-gray-700' : 'bg-white border-gray-200',
    cardHeader: theme === 'dark' ? 'text-white' : 'text-gray-900',
    text: theme === 'dark' ? 'text-gray-300' : 'text-gray-900',
    textSecondary: theme === 'dark' ? 'text-gray-400' : 'text-gray-600',
    highlight: theme === 'dark' ? 'text-blue-400' : 'text-blue-600',
    hover: theme === 'dark' ? 'hover:bg-gray-700' : 'hover:bg-gray-50',
    border: theme === 'dark' ? 'border-gray-700' : 'border-gray-200',
    inputBg: theme === 'dark' ? '' : 'bg-gray-50',
  };


  const switchDeposito = (deposito) => {
    switch (deposito) {
      case "C1":
        return "CASORIA";
      case "D1":
        return "CASERTA";
      case "U1":
        return "PESARO";
      case "T1":
        return "BARBERINO";
      case "P1":
        return "PESCARA";
      default:
        return "CASORIA";
    }
  };

  const fetchAddresses = async (codice_cliente) => {
    try {
      const response = await fetch("/nodeapi/indirizzi", {
        method: "POST",
        headers: { 
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
         },
        body: JSON.stringify({ codice_cliente }),
      });
    if (response.status === 401 || response.status === 403 || response.status === 500) {
        handleLogout();
        return;
      }
      const resData = await response.json();
      const decrypted = decryptData(
        resData.encryptedData,
        resData.encryptedKey,
        resData.iv
      );
      const decryptedJson = JSON.parse(decrypted);
      if (decryptedJson.status === "success") {
        setAddresses(decryptedJson.data);
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  const fetchOrderDetails = async () => {
    try {
      setLoading(true);
      const [numeroOrdine, annoRif] = id.split("-");
      const response = await fetch("/nodeapi/ordini_dettagli", {
        method: "POST",
        headers: { 
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
         },
        body: JSON.stringify({
          numero_ordine: numeroOrdine,
          anno_rif: annoRif,
        }),
      });
    if (response.status !== 200 && response.status !== 201) {
          handleLogout(response, "/nodeapi/ordini_dettagli", JSON.stringify({
          numero_ordine: numeroOrdine,
          anno_rif: annoRif,
        }));
         return;
       }
      const resData = await response.json();
      const decrypted = decryptData(
        resData.encryptedData,
        resData.encryptedKey,
        resData.iv
      );
      const decryptedJson = JSON.parse(decrypted);
      console.log("Decrypted JSON:", decryptedJson);
      if (decryptedJson.status === "success" && decryptedJson.data.length > 0) {
        const details = decryptedJson.data;
        const first = details[0];
        const orderData = {
          numero_ordine: first.NUMERO_ORDINE,
          anno_ordine: first.ANNO_RIF,
          ragione_sociale: first.RAGIONE_SOCIALE,
          data_ordine: moment(String(first.DATA_ORDINE), "YYYYMMDD").format(
            "DD/MM/YYYY"
          ),
          codice_cliente: first.CODICE_CLIENTE,
          ritiro_cliente: first.RITIRO_CLIENTE,
          tipo_consegna: first.TIPO_CONSEGNA,
          riferimento_cliente: first.RIFERIMENTO_CLIENTE,
          data_consegna_richiesta: moment(
            String(first.DATA_CONSEGNA_RICHIESTA),
            "YYYYMMDD"
          ).format("DD/MM/YYYY"),
          totale_trasporto: details.reduce(
            (acc, curr) => acc + Number(curr.IMPORTO_RIGA),
            0
          ),
          somma_rae: details.reduce(
            (acc, curr) => acc + Number(curr.IMPORTO_RAE),
            0
          ),
          totale_ordine: details.reduce(
            (acc, curr) => acc + Number(curr.PREZZO_FINALE),
            0
          ),
          products: details.map((item) => ({
            codice_articolo: item.CODICE_ARTICOLO,
            descrizione_articolo: item.DESCRIZIONE_ARTICOLO,
            deposito: item.DEPOSITO,
            sconto1: item.SCONTO1,
            sconto2: item.SCONTO2,
            sconto3: item.SCONTO3,
            quantita: item.QUANTITA,
            quantita_assegnata: item.QUANTITA_ASSEGNATA,
            quantita_consegnata: item.QUANTITA_CONSEGNATA,
            prezzo_listino: item.PREZZO_LISTINO,
            prezzo_finale: item.PREZZO_FINALE,
          })),
        };
        setOrder(orderData);
        // Chiama fetchAddresses con il codice cliente
        fetchAddresses(first.CODICE_CLIENTE);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-lg text-gray-600">Nessun dettaglio trovato</div>
      </div>
    );
  }

  const totals = {
    quantita: order.products.reduce(
      (acc, curr) => acc + Number(curr.quantita),
      0
    ),
    consegnata: order.products.reduce(
      (acc, curr) => acc + Number(curr.quantita_consegnata),
      0
    ),
    assegnata: order.products.reduce(
      (acc, curr) => acc + Number(curr.quantita_assegnata),
      0
    ),
  };

  return (
    <div className={`min-h-screen ${baseClasses.background}`}>
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Header Section */}
        <div className="relative sm:max-w-4xl px-5 sm:px-12 mx-auto flex flex-col justify-between mb-12 md:mt-50">
          <div className="sm:max-w-4xl px-5 sm:px-12 mx-auto flex-col justify-between  mt-cu-md md:mt-20">
          </div>
        </div>
        <div className={`rounded-lg p-6 mb-6 border ${baseClasses.card}`}>
          <div className="flex items-center space-x-4 mb-8">
            <button
              onClick={() => navigate(-1)}
              className={`p-2 rounded-full ${baseClasses.hover} transition-colors`}
            >
              <span className={`material-symbols-outlined ${baseClasses.highlight}`}>
                arrow_back
              </span>
            </button>
            <h1 className={`text-3xl font-bold ${baseClasses.cardHeader}`}>
              Ordine <span className={baseClasses.highlight}>{order.numero_ordine}</span>
            </h1>
          </div>
  
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { label: "Numero ordine", value: order.numero_ordine },
              { label: "Ragione sociale", value: order.ragione_sociale },
              { label: "Anno ordine", value: order.anno_ordine },
              { label: "Data ordine", value: order.data_ordine },
            ].map((item, index) => (
              <div key={index} className={`rounded-lg p-4 ${baseClasses.inputBg}`}>
                <div className={`text-sm mb-1 ${baseClasses.textSecondary}`}>
                  {item.label}
                </div>
                <div className={`text-lg font-medium ${baseClasses.highlight}`}>
                  {item.value}
                </div>
              </div>
            ))}
          </div>
        </div>
  
        {/* Additional Info Section */}
        <div className={`rounded-lg mb-6 border ${baseClasses.card}`}>
          <button
            onClick={() => setCollapseActive(!collapseActive)}
            className={`w-full px-6 py-4 flex items-center justify-between ${baseClasses.hover} transition-colors`}
          >
            <span className={`text-lg font-medium ${baseClasses.cardHeader}`}>
              {collapseActive ? "Meno Informazioni" : "Maggiori Informazioni"}
            </span>
            <span className={`material-symbols-outlined ${baseClasses.highlight}`}>
              {collapseActive ? "expand_less" : "expand_more"}
            </span>
          </button>
  
          {collapseActive && (
            <div className={`px-6 py-4 border-t ${baseClasses.border}`}>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { label: "Data Consegna Richiesta", value: order.data_consegna_richiesta },
                  { label: "Rif Cliente", value: order.riferimento_cliente || "-" },
                  { label: "Ritiro Cliente", value: order.ritiro_cliente },
                  { label: "Tipo Consegna", value: order.tipo_consegna },
                  { 
                    label: "Importo Prodotti", 
                    value: Number(order.totale_trasporto).toLocaleString("it-IT", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 0,
                    })
                  },
                  {
                    label: "Spesa RAE",
                    value: Number(order.somma_rae).toLocaleString("it-IT", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 0,
                    })
                  },
                  {
                    label: "Totale",
                    value: Number(order.totale_ordine).toLocaleString("it-IT", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 0,
                    })
                  },
                  { label: "Codice Cliente", value: order.codice_cliente }
                ].map((item, index) => (
                  <div key={index} className={`rounded-lg p-4 ${baseClasses.inputBg}`}>
                    <div className={`text-sm mb-1 ${baseClasses.textSecondary}`}>
                      {item.label}
                    </div>
                    <div className={`text-lg font-medium ${baseClasses.highlight}`}>
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
  
        {/* Addresses Section */}
        <div className={`rounded-lg mb-6 border ${baseClasses.card}`}>
          <div className={`px-6 py-4 border-b ${baseClasses.border}`}>
            <h2 className={`text-lg font-medium ${baseClasses.cardHeader}`}>
              Indirizzi di Consegna
            </h2>
          </div>
          <div className="px-6 py-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {addresses.length > 0 ? (
                addresses.map((addr, index) => (
                  <div key={index} className={`rounded-lg p-4 ${baseClasses.inputBg}`}>
                    <div className={`text-sm font-medium mb-3 ${baseClasses.textSecondary}`}>
                      Indirizzo {index + 1}
                    </div>
                    <div className="space-y-2">
                      <div className={`text-sm ${baseClasses.text}`}>{addr.INDIRIZZO}</div>
                      <div className={`text-sm ${baseClasses.text}`}>{addr.CAP}</div>
                      <div className={`text-sm ${baseClasses.text}`}>{addr.CITTA}</div>
                      <div className={`text-sm ${baseClasses.text}`}>{addr.PROVINCIA}</div>
                      {addr.TEL && (
                        <div className={`text-sm ${baseClasses.text}`}>
                          <span className={baseClasses.textSecondary}>Tel:</span> {addr.TEL}
                        </div>
                      )}
                      {addr.EMAIL && (
                        <div className={`text-sm ${baseClasses.text}`}>
                          <span className={baseClasses.textSecondary}>Email:</span> {addr.EMAIL}
                        </div>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className={`rounded-lg p-4 ${baseClasses.inputBg} col-span-full`}>
                  <div className={`text-center ${baseClasses.textSecondary}`}>
                    Nessun indirizzo disponibile
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
  
        {/* Products Section */}
        <div className={`rounded-lg p-6 border ${baseClasses.card}`}>
          <h2 className={`text-2xl font-bold mb-6 ${baseClasses.cardHeader}`}>
            Riepilogo Prodotti
          </h2>
  
          {/* Summary Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            {[
              { label: "Quantità ordinata", value: totals.quantita },
              { label: "Quantità consegnata", value: totals.consegnata },
              { label: "Quantità assegnata", value: totals.assegnata },
              {
                label: "Totale prodotti",
                value: Number(order.totale_ordine).toLocaleString("it-IT", {
                  style: "currency",
                  currency: "EUR",
                  maximumFractionDigits: 0,
                })
              }
            ].map((item, index) => (
              <div key={index} className={`rounded-lg p-4 ${baseClasses.inputBg}`}>
                <div className={`text-sm mb-1 ${baseClasses.textSecondary}`}>
                  {item.label}
                </div>
                <div className={`text-lg font-medium ${baseClasses.highlight}`}>
                  {item.value}
                </div>
              </div>
            ))}
          </div>
  
          {/* Products Table */}
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className={baseClasses.inputBg}>
                <tr>
                  {[
                    "Prodotto", "Descrizione", "Deposito", "Prezzo Base",
                    "Sconto 1", "Sconto 2", "Sconto 3", "Q.tà Ordinata", "Q.tà Assegnata",
                    "Q.tà Consegnata", "Totale"
                  ].map((header, index) => (
                    <th key={index} className={`px-6 py-3 ${index >= 4 && index <= 9 ? 'text-center' : index === 10 ? 'text-right' : 'text-left'} text-xs font-medium ${baseClasses.textSecondary} uppercase tracking-wider`}>
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className={`${baseClasses.card} divide-y ${baseClasses.border}`}>
                {order.products.map((product, index) => (
                  <tr key={index} className={baseClasses.hover}>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${baseClasses.text}`}>
                      {product.codice_articolo}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${baseClasses.text}`}>
                      {product.descrizione_articolo}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${baseClasses.text}`}>
                      {product.deposito}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${baseClasses.text}`}>
                      {Number(product.prezzo_listino).toLocaleString("it-IT", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${baseClasses.text} text-center`}>
                      {product.sconto1 ? `${product.sconto1}%` : '—'}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${baseClasses.text} text-center`}>
                      {product.sconto2 ? `${product.sconto2}%` : '—'}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${baseClasses.text} text-center`}>
                      {product.sconto3 ? `${product.sconto3}%` : '—'}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${baseClasses.text} text-center`}>
                      {product.quantita}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${baseClasses.text} text-center`}>
                      {product.quantita_assegnata}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${baseClasses.text} text-center`}>
                      {product.quantita_consegnata}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${baseClasses.text} text-right`}>
                      {Number(product.prezzo_finale).toLocaleString("it-IT", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}